import {VNode} from 'snabbdom';

import {Translatable} from 'common/i18n';

export interface TooltipState {
  visibility: string;
  isFirstActiveTooltip: boolean;
}

export enum Placement {
  Top = `top`,
  Right = `right`,
  RightCenter = `right-center`,
  RightEnd = `right-end`,
  Bottom = `bottom`,
  Left = `left`,
  LeftCenter = `left-center`,
  LeftEnd = `left-end`,
}
export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum DisplayType {
  Default = `default`,
  Error = `error`,
}

export enum TooltipTextAlign {
  Start = `start`,
  Center = `center`,
  End = `end`,
}
export enum DisplaySize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,

  Fit = `fit`,
}

export type TooltipAttrs = {
  'is-tooltip-tour'?: boolean;
  'always-show'?: boolean;
  'break-word'?: boolean;
  'delay-in'?: number;
  'delay-out'?: number;
  'max-width'?: string;
  offset?: number;
  skidding?: number;
  placement?: Placement;
  type?: DisplayType;
  'image-src'?: string;
  size?: DisplaySize;
  text?: Translatable;
  'position-strategy'?: PositioningStrategy;
  'allowed-flip-directions'?: Placement[];
  'experimental-positioning'?: boolean;
  'text-align'?: TooltipTextAlign;
};

export type TooltipParams = {
  text?: Translatable;
};

export interface TooltipJsxProps {
  attrs?: TooltipAttrs;
  params?: TooltipParams;
  on?: {
    showed: () => void;
  };
  props?: {
    /** for expensive components/templates that will only render when tooltip is visible */
    lazyContentRenderer?: () => VNode;
    parentEl?: HTMLElement;
  };
}
